import React, { useState } from 'react';

import { Button, Typography } from '@mui/material';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

import { COLOR_GREY_200, COLOR_GREY_400, COLOR_GREY_600 } from 'src/utils/colors';

const EditButton = ({
  actionOnClick,
  isDisabled,
  isLocked,
  Icon,
  title,
}: {
  actionOnClick: () => void;
  isDisabled?: boolean;
  isLocked: boolean;
  Icon?: any;
  title?: any;
}) => {
  const theme = useTheme();
  const isMobileDevice = useMediaQuery(theme.breakpoints.down(900));
  const [showEditText, setShowEditText] = useState(false);

  const buttonIconStyle = { px: '0 !important', margin: '0 !important', ...(isMobileDevice ? { fontSize: '14px' } : {}) };

  return (
    <Button
      size="small"
      onClick={() => !isDisabled && actionOnClick()}
      disabled={isDisabled}
      onMouseEnter={() => !isMobileDevice && setShowEditText(true)}
      onMouseLeave={() => !isMobileDevice && setShowEditText(false)}
      sx={{
        background: COLOR_GREY_200,
        color: COLOR_GREY_600,
        fontSize: isMobileDevice ? '10px' : '16px',
        minWidth: isMobileDevice ? '24px' : showEditText ? '100px' : '50px',
        width: isMobileDevice ? '24px' : showEditText ? '100px' : '50px',
        height: isMobileDevice ? '24px' : 'auto',
        padding: isMobileDevice ? '2px' : undefined,
        overflow: 'hidden',
        transition: 'all 0.25s ease',
        '&:hover': {
          width: isMobileDevice ? '24px' : '100px',
          background: isMobileDevice ? COLOR_GREY_200 : '#222',
          color: isMobileDevice ? COLOR_GREY_600 : '#fff',
        },
      }}
    >
      {isLocked ? (
        <LockOutlinedIcon sx={{ px: '0 !important', margin: '0 !important' }} />
      ) : Icon ? (
        <Icon sx={buttonIconStyle} />
      ) : (
        <ModeEditOutlineOutlinedIcon sx={buttonIconStyle} />
      )}
      {showEditText && (
        <Typography variant="button" sx={{ opacity: showEditText ? 1 : 0, overflow: 'hidden' }}>
          {title ? title : 'Edit'}
        </Typography>
      )}
    </Button>
  );
};

export default EditButton;
